/**
 * Labstep
 *
 * @module components/Experiment/IsReady
 * @desc Screen when experiment is not ready
 */

import { LayoutLoadingContent } from 'labstep-web/components/Layout/LoadingContent';
import { Card } from 'labstep-web/core/Card/Card';
import { Flex } from 'labstep-web/core/Flex';
import { Loader } from 'labstep-web/core/Loader';
import { updateEntity } from 'labstep-web/state/actions/entity';
import type React from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import type { ExperimentIsReadyProps } from './types';

export const ExperimentIsReady: React.FC<ExperimentIsReadyProps> = ({
  experiment,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      updateEntity(experiment.entityName, experiment.id, {
        is_ready: true,
      }),
    );
  }, [dispatch, experiment.entityName, experiment.id]);

  return (
    <LayoutLoadingContent
      status={{ isFetching: true }}
      loader="main_content"
      children={null}
    />
  );
};
